import { render, staticRenderFns } from "./Investigation.vue?vue&type=template&id=07f90355&scoped=true&"
import script from "./Investigation.vue?vue&type=script&lang=ts&"
export * from "./Investigation.vue?vue&type=script&lang=ts&"
import style0 from "./Investigation.vue?vue&type=style&index=0&id=07f90355&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f90355",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07f90355')) {
      api.createRecord('07f90355', component.options)
    } else {
      api.reload('07f90355', component.options)
    }
    module.hot.accept("./Investigation.vue?vue&type=template&id=07f90355&scoped=true&", function () {
      api.rerender('07f90355', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/data-entry/sections/investigations/Investigation.vue"
export default component.exports